/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface SkillsService {
  /** @summary Get All */
  getAllSkillsGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetAllSkillsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllSkillsGetSchema,
        options: {
          parameters: GetAllSkillsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllSkillsGetData, GetAllSkillsGetError>>
    ): Promise<RequestFnResponse<GetAllSkillsGetData, GetAllSkillsGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllSkillsGetParameters> | void
    ): ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.skillsService.getAllSkillsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllSkillsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        | (DeepReadonly<GetAllSkillsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllSkillsGetData,
          GetAllSkillsGetError,
          TData,
          ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllSkillsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.skillsService.getAllSkillsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllSkillsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        | (DeepReadonly<GetAllSkillsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllSkillsGetData,
          GetAllSkillsGetError,
          TData,
          ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllSkillsGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllSkillsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.skillsService.getAllSkillsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllSkillsGetParameters,
      TQueryFnData = GetAllSkillsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllSkillsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        | (DeepReadonly<GetAllSkillsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllSkillsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllSkillsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.skillsService.getAllSkillsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllSkillsGetParameters,
      TQueryFnData = GetAllSkillsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllSkillsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        | (DeepReadonly<GetAllSkillsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllSkillsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllSkillsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllSkillsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllSkillsGetTotal = qraft.skillsService.getAllSkillsGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllSkillsGetResults = qraft.skillsService.getAllSkillsGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllSkillsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllSkillsGetCombinedResults = qraft.skillsService.getAllSkillsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllSkillsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllSkillsGetSchema,
          GetAllSkillsGetParameters,
          GetAllSkillsGetData,
          GetAllSkillsGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllSkillsGetData, GetAllSkillsGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAllSkillsGetData, GetAllSkillsGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.skillsService.getAllSkillsGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllSkillsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        | (DeepReadonly<GetAllSkillsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllSkillsGetData,
          GetAllSkillsGetError,
          TData,
          ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllSkillsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.skillsService.getAllSkillsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAllSkillsGetParameters, TData = GetAllSkillsGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        | (DeepReadonly<GetAllSkillsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllSkillsGetData,
          GetAllSkillsGetError,
          OperationInfiniteData<TData, GetAllSkillsGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllSkillsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllSkillsGetParameters>,
      OperationError<GetAllSkillsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllSkillsGetData = qraft.skillsService.getAllSkillsGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllSkillsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllSkillsGetCombinedData = qraft.skillsService.getAllSkillsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllSkillsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllSkillsGetSchema,
          GetAllSkillsGetParameters,
          GetAllSkillsGetData,
          GetAllSkillsGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAllSkillsGetData, GetAllSkillsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAllSkillsGetData, GetAllSkillsGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllSkillsGetSchema,
        GetAllSkillsGetData,
        GetAllSkillsGetParameters,
        GetAllSkillsGetError
      > | void
    ): Promise<GetAllSkillsGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllSkillsGetSchema,
        GetAllSkillsGetData,
        GetAllSkillsGetParameters,
        GetAllSkillsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllSkillsGetSchema,
        GetAllSkillsGetData,
        GetAllSkillsGetParameters,
        GetAllSkillsGetError
      > | void
    ): Promise<GetAllSkillsGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllSkillsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllSkillsGetSchema,
        GetAllSkillsGetData,
        GetAllSkillsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllSkillsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllSkillsGetData, GetAllSkillsGetParameters>>;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllSkillsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllSkillsGetSchema,
        GetAllSkillsGetData,
        GetAllSkillsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllSkillsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllSkillsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllSkillsGetSchema,
        GetAllSkillsGetData,
        GetAllSkillsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllSkillsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllSkillsGetData, GetAllSkillsGetParameters>>;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        | (DeepReadonly<GetAllSkillsGetParameters> | void)
    ): GetAllSkillsGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        | (DeepReadonly<GetAllSkillsGetParameters> | void)
    ): OperationInfiniteData<GetAllSkillsGetData, GetAllSkillsGetParameters> | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>,
            data: NoInfer<OperationInfiniteData<GetAllSkillsGetData, GetAllSkillsGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>,
            data: GetAllSkillsGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        | (DeepReadonly<GetAllSkillsGetParameters> | void)
    ): QueryState<GetAllSkillsGetData, GetAllSkillsGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllSkillsGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<GetAllSkillsGetData, GetAllSkillsGetParameters>, GetAllSkillsGetError>
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllSkillsGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>,
      updater: Updater<
        NoInfer<GetAllSkillsGetData> | undefined,
        NoInfer<DeepReadonly<GetAllSkillsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllSkillsGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllSkillsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllSkillsGetSchema, GetAllSkillsGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAllSkillsGetData, GetAllSkillsGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAllSkillsGetData, GetAllSkillsGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllSkillsGetData, GetAllSkillsGetParameters> | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >,
      updater: Updater<NoInfer<GetAllSkillsGetData> | undefined, NoInfer<GetAllSkillsGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAllSkillsGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllSkillsGetSchema,
        GetAllSkillsGetData,
        TInfinite,
        GetAllSkillsGetParameters,
        GetAllSkillsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllSkillsGetSchema,
            GetAllSkillsGetData,
            TInfinite,
            GetAllSkillsGetParameters,
            GetAllSkillsGetError
          >
    ): number;
    schema: GetAllSkillsGetSchema;
    types: {
      parameters: GetAllSkillsGetParameters;
      data: GetAllSkillsGetData;
      error: GetAllSkillsGetError;
    };
  };
  /** @summary Create */
  createSkillsPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateSkillsPostBody, CreateSkillsPostParameters, TMeta, TSignal>,
      client?: (
        schema: CreateSkillsPostSchema,
        options: ServiceOperationMutationFnOptions<CreateSkillsPostBody, CreateSkillsPostParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateSkillsPostData, CreateSkillsPostError>>
    ): Promise<RequestFnResponse<CreateSkillsPostData, CreateSkillsPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateSkillsPostParameters> | void
    ): ServiceOperationMutationKey<CreateSkillsPostSchema, CreateSkillsPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.createSkillsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.createSkillsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateSkillsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateSkillsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateSkillsPostSchema,
        CreateSkillsPostData,
        CreateSkillsPostParameters,
        TVariables,
        OperationError<CreateSkillsPostError>,
        TContext
      >
    ): UseMutationResult<CreateSkillsPostData, OperationError<CreateSkillsPostError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.createSkillsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.createSkillsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateSkillsPostBody, CreateSkillsPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateSkillsPostSchema,
        CreateSkillsPostData,
        CreateSkillsPostParameters,
        TVariables,
        OperationError<CreateSkillsPostError>,
        TContext
      >
    ): UseMutationResult<CreateSkillsPostData, OperationError<CreateSkillsPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createSkillsPostTotal = qraft.skillsService.createSkillsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createSkillsPostTotal = qraft.skillsService.createSkillsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateSkillsPostBody,
            CreateSkillsPostData,
            CreateSkillsPostParameters,
            OperationError<CreateSkillsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateSkillsPostSchema,
            CreateSkillsPostBody,
            CreateSkillsPostData,
            CreateSkillsPostParameters,
            OperationError<CreateSkillsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createSkillsPostPendingMutationVariables = qraft.skillsService.createSkillsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createSkillsPostMutationData = qraft.skillsService.createSkillsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateSkillsPostData,
        OperationError<CreateSkillsPostError>,
        MutationVariables<CreateSkillsPostBody, CreateSkillsPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateSkillsPostBody,
            CreateSkillsPostData,
            CreateSkillsPostParameters,
            OperationError<CreateSkillsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateSkillsPostSchema,
            CreateSkillsPostBody,
            CreateSkillsPostData,
            CreateSkillsPostParameters,
            OperationError<CreateSkillsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateSkillsPostData,
          OperationError<CreateSkillsPostError>,
          MutationVariables<CreateSkillsPostBody, CreateSkillsPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateSkillsPostBody,
            CreateSkillsPostData,
            CreateSkillsPostParameters,
            OperationError<CreateSkillsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateSkillsPostSchema,
            CreateSkillsPostBody,
            CreateSkillsPostData,
            CreateSkillsPostParameters,
            OperationError<CreateSkillsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.skillsService.createSkillsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.skillsService.createSkillsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateSkillsPostBody,
              CreateSkillsPostData,
              CreateSkillsPostParameters,
              OperationError<CreateSkillsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateSkillsPostSchema,
              CreateSkillsPostBody,
              CreateSkillsPostData,
              CreateSkillsPostParameters,
              OperationError<CreateSkillsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateSkillsPostData,
            CreateSkillsPostError,
            MutationVariables<CreateSkillsPostBody, CreateSkillsPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateSkillsPostBody,
              CreateSkillsPostData,
              CreateSkillsPostParameters,
              OperationError<CreateSkillsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateSkillsPostSchema,
              CreateSkillsPostBody,
              CreateSkillsPostData,
              CreateSkillsPostParameters,
              OperationError<CreateSkillsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateSkillsPostData,
          CreateSkillsPostError,
          MutationVariables<CreateSkillsPostBody, CreateSkillsPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateSkillsPostSchema;
    types: {
      parameters: CreateSkillsPostParameters;
      data: CreateSkillsPostData;
      error: CreateSkillsPostError;
      body: CreateSkillsPostBody;
    };
  };
  /** @summary Update */
  updateSkillsSkillIdPatch: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateSkillsSkillIdPatchBody,
        UpdateSkillsSkillIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateSkillsSkillIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateSkillsSkillIdPatchBody,
          UpdateSkillsSkillIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateSkillsSkillIdPatchData, UpdateSkillsSkillIdPatchError>>
    ): Promise<RequestFnResponse<UpdateSkillsSkillIdPatchData, UpdateSkillsSkillIdPatchError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateSkillsSkillIdPatchParameters> | void
    ): ServiceOperationMutationKey<UpdateSkillsSkillIdPatchSchema, UpdateSkillsSkillIdPatchParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.updateSkillsSkillIdPatch.useMutation({
     *     path: {
     *         skill_id: skillId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.updateSkillsSkillIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         skill_id: skillId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateSkillsSkillIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateSkillsSkillIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateSkillsSkillIdPatchSchema,
        UpdateSkillsSkillIdPatchData,
        UpdateSkillsSkillIdPatchParameters,
        TVariables,
        OperationError<UpdateSkillsSkillIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateSkillsSkillIdPatchData,
      OperationError<UpdateSkillsSkillIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.updateSkillsSkillIdPatch.useMutation({
     *     path: {
     *         skill_id: skillId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.updateSkillsSkillIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         skill_id: skillId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateSkillsSkillIdPatchBody, UpdateSkillsSkillIdPatchParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateSkillsSkillIdPatchSchema,
        UpdateSkillsSkillIdPatchData,
        UpdateSkillsSkillIdPatchParameters,
        TVariables,
        OperationError<UpdateSkillsSkillIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateSkillsSkillIdPatchData,
      OperationError<UpdateSkillsSkillIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateSkillsSkillIdPatchTotal = qraft.skillsService.updateSkillsSkillIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateSkillsSkillIdPatchTotal = qraft.skillsService.updateSkillsSkillIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             skill_id: skillId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateSkillsSkillIdPatchBody,
            UpdateSkillsSkillIdPatchData,
            UpdateSkillsSkillIdPatchParameters,
            OperationError<UpdateSkillsSkillIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateSkillsSkillIdPatchSchema,
            UpdateSkillsSkillIdPatchBody,
            UpdateSkillsSkillIdPatchData,
            UpdateSkillsSkillIdPatchParameters,
            OperationError<UpdateSkillsSkillIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateSkillsSkillIdPatchPendingMutationVariables = qraft.skillsService.updateSkillsSkillIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateSkillsSkillIdPatchMutationData = qraft.skillsService.updateSkillsSkillIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 skill_id: skillId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateSkillsSkillIdPatchData,
        OperationError<UpdateSkillsSkillIdPatchError>,
        MutationVariables<UpdateSkillsSkillIdPatchBody, UpdateSkillsSkillIdPatchParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateSkillsSkillIdPatchBody,
            UpdateSkillsSkillIdPatchData,
            UpdateSkillsSkillIdPatchParameters,
            OperationError<UpdateSkillsSkillIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateSkillsSkillIdPatchSchema,
            UpdateSkillsSkillIdPatchBody,
            UpdateSkillsSkillIdPatchData,
            UpdateSkillsSkillIdPatchParameters,
            OperationError<UpdateSkillsSkillIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateSkillsSkillIdPatchData,
          OperationError<UpdateSkillsSkillIdPatchError>,
          MutationVariables<UpdateSkillsSkillIdPatchBody, UpdateSkillsSkillIdPatchParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateSkillsSkillIdPatchBody,
            UpdateSkillsSkillIdPatchData,
            UpdateSkillsSkillIdPatchParameters,
            OperationError<UpdateSkillsSkillIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateSkillsSkillIdPatchSchema,
            UpdateSkillsSkillIdPatchBody,
            UpdateSkillsSkillIdPatchData,
            UpdateSkillsSkillIdPatchParameters,
            OperationError<UpdateSkillsSkillIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.skillsService.updateSkillsSkillIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             skill_id: skillId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.skillsService.updateSkillsSkillIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateSkillsSkillIdPatchBody,
              UpdateSkillsSkillIdPatchData,
              UpdateSkillsSkillIdPatchParameters,
              OperationError<UpdateSkillsSkillIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateSkillsSkillIdPatchSchema,
              UpdateSkillsSkillIdPatchBody,
              UpdateSkillsSkillIdPatchData,
              UpdateSkillsSkillIdPatchParameters,
              OperationError<UpdateSkillsSkillIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateSkillsSkillIdPatchData,
            UpdateSkillsSkillIdPatchError,
            MutationVariables<UpdateSkillsSkillIdPatchBody, UpdateSkillsSkillIdPatchParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateSkillsSkillIdPatchBody,
              UpdateSkillsSkillIdPatchData,
              UpdateSkillsSkillIdPatchParameters,
              OperationError<UpdateSkillsSkillIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateSkillsSkillIdPatchSchema,
              UpdateSkillsSkillIdPatchBody,
              UpdateSkillsSkillIdPatchData,
              UpdateSkillsSkillIdPatchParameters,
              OperationError<UpdateSkillsSkillIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateSkillsSkillIdPatchData,
          UpdateSkillsSkillIdPatchError,
          MutationVariables<UpdateSkillsSkillIdPatchBody, UpdateSkillsSkillIdPatchParameters>,
          TContext
        >
      >;
    };
    schema: UpdateSkillsSkillIdPatchSchema;
    types: {
      parameters: UpdateSkillsSkillIdPatchParameters;
      data: UpdateSkillsSkillIdPatchData;
      error: UpdateSkillsSkillIdPatchError;
      body: UpdateSkillsSkillIdPatchBody;
    };
  };
  /** @summary Remove */
  removeSkillsSkillIdDelete: {
    /** @summary Remove */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RemoveSkillsSkillIdDeleteBody,
        RemoveSkillsSkillIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RemoveSkillsSkillIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          RemoveSkillsSkillIdDeleteBody,
          RemoveSkillsSkillIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<RemoveSkillsSkillIdDeleteData, RemoveSkillsSkillIdDeleteError>>
    ): Promise<RequestFnResponse<RemoveSkillsSkillIdDeleteData, RemoveSkillsSkillIdDeleteError>>;
    /** @summary Remove */
    getMutationKey(
      parameters: DeepReadonly<RemoveSkillsSkillIdDeleteParameters> | void
    ): ServiceOperationMutationKey<RemoveSkillsSkillIdDeleteSchema, RemoveSkillsSkillIdDeleteParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.removeSkillsSkillIdDelete.useMutation({
     *     path: {
     *         skill_id: skillId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.removeSkillsSkillIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         skill_id: skillId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends RemoveSkillsSkillIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<RemoveSkillsSkillIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        RemoveSkillsSkillIdDeleteSchema,
        RemoveSkillsSkillIdDeleteData,
        RemoveSkillsSkillIdDeleteParameters,
        TVariables,
        OperationError<RemoveSkillsSkillIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveSkillsSkillIdDeleteData,
      OperationError<RemoveSkillsSkillIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.removeSkillsSkillIdDelete.useMutation({
     *     path: {
     *         skill_id: skillId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.skillsService.removeSkillsSkillIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         skill_id: skillId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<RemoveSkillsSkillIdDeleteBody, RemoveSkillsSkillIdDeleteParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RemoveSkillsSkillIdDeleteSchema,
        RemoveSkillsSkillIdDeleteData,
        RemoveSkillsSkillIdDeleteParameters,
        TVariables,
        OperationError<RemoveSkillsSkillIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveSkillsSkillIdDeleteData,
      OperationError<RemoveSkillsSkillIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const removeSkillsSkillIdDeleteTotal = qraft.skillsService.removeSkillsSkillIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const removeSkillsSkillIdDeleteTotal = qraft.skillsService.removeSkillsSkillIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             skill_id: skillId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RemoveSkillsSkillIdDeleteBody,
            RemoveSkillsSkillIdDeleteData,
            RemoveSkillsSkillIdDeleteParameters,
            OperationError<RemoveSkillsSkillIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveSkillsSkillIdDeleteSchema,
            RemoveSkillsSkillIdDeleteBody,
            RemoveSkillsSkillIdDeleteData,
            RemoveSkillsSkillIdDeleteParameters,
            OperationError<RemoveSkillsSkillIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const removeSkillsSkillIdDeletePendingMutationVariables = qraft.skillsService.removeSkillsSkillIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const removeSkillsSkillIdDeleteMutationData = qraft.skillsService.removeSkillsSkillIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 skill_id: skillId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RemoveSkillsSkillIdDeleteData,
        OperationError<RemoveSkillsSkillIdDeleteError>,
        MutationVariables<RemoveSkillsSkillIdDeleteBody, RemoveSkillsSkillIdDeleteParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RemoveSkillsSkillIdDeleteBody,
            RemoveSkillsSkillIdDeleteData,
            RemoveSkillsSkillIdDeleteParameters,
            OperationError<RemoveSkillsSkillIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveSkillsSkillIdDeleteSchema,
            RemoveSkillsSkillIdDeleteBody,
            RemoveSkillsSkillIdDeleteData,
            RemoveSkillsSkillIdDeleteParameters,
            OperationError<RemoveSkillsSkillIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RemoveSkillsSkillIdDeleteData,
          OperationError<RemoveSkillsSkillIdDeleteError>,
          MutationVariables<RemoveSkillsSkillIdDeleteBody, RemoveSkillsSkillIdDeleteParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Remove */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RemoveSkillsSkillIdDeleteBody,
            RemoveSkillsSkillIdDeleteData,
            RemoveSkillsSkillIdDeleteParameters,
            OperationError<RemoveSkillsSkillIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveSkillsSkillIdDeleteSchema,
            RemoveSkillsSkillIdDeleteBody,
            RemoveSkillsSkillIdDeleteData,
            RemoveSkillsSkillIdDeleteParameters,
            OperationError<RemoveSkillsSkillIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.skillsService.removeSkillsSkillIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             skill_id: skillId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.skillsService.removeSkillsSkillIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RemoveSkillsSkillIdDeleteBody,
              RemoveSkillsSkillIdDeleteData,
              RemoveSkillsSkillIdDeleteParameters,
              OperationError<RemoveSkillsSkillIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveSkillsSkillIdDeleteSchema,
              RemoveSkillsSkillIdDeleteBody,
              RemoveSkillsSkillIdDeleteData,
              RemoveSkillsSkillIdDeleteParameters,
              OperationError<RemoveSkillsSkillIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            RemoveSkillsSkillIdDeleteData,
            RemoveSkillsSkillIdDeleteError,
            MutationVariables<RemoveSkillsSkillIdDeleteBody, RemoveSkillsSkillIdDeleteParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RemoveSkillsSkillIdDeleteBody,
              RemoveSkillsSkillIdDeleteData,
              RemoveSkillsSkillIdDeleteParameters,
              OperationError<RemoveSkillsSkillIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveSkillsSkillIdDeleteSchema,
              RemoveSkillsSkillIdDeleteBody,
              RemoveSkillsSkillIdDeleteData,
              RemoveSkillsSkillIdDeleteParameters,
              OperationError<RemoveSkillsSkillIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          RemoveSkillsSkillIdDeleteData,
          RemoveSkillsSkillIdDeleteError,
          MutationVariables<RemoveSkillsSkillIdDeleteBody, RemoveSkillsSkillIdDeleteParameters>,
          TContext
        >
      >;
    };
    schema: RemoveSkillsSkillIdDeleteSchema;
    types: {
      parameters: RemoveSkillsSkillIdDeleteParameters;
      data: RemoveSkillsSkillIdDeleteData;
      error: RemoveSkillsSkillIdDeleteError;
      body: RemoveSkillsSkillIdDeleteBody;
    };
  };
}
/** @summary Get All */
export const getAllSkillsGet = {
  schema: {
    method: 'get',
    url: '/skills',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllSkillsGetSchema;
  [QraftServiceOperationsToken]: SkillsService['getAllSkillsGet'];
};
/** @summary Create */
export const createSkillsPost = {
  schema: {
    method: 'post',
    url: '/skills',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateSkillsPostSchema;
  [QraftServiceOperationsToken]: SkillsService['createSkillsPost'];
};
/** @summary Update */
export const updateSkillsSkillIdPatch = {
  schema: {
    method: 'patch',
    url: '/skills/{skill_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateSkillsSkillIdPatchSchema;
  [QraftServiceOperationsToken]: SkillsService['updateSkillsSkillIdPatch'];
};
/** @summary Remove */
export const removeSkillsSkillIdDelete = {
  schema: {
    method: 'delete',
    url: '/skills/{skill_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: RemoveSkillsSkillIdDeleteSchema;
  [QraftServiceOperationsToken]: SkillsService['removeSkillsSkillIdDelete'];
};
export const skillsService = {
  getAllSkillsGet,
  createSkillsPost,
  updateSkillsSkillIdPatch,
  removeSkillsSkillIdDelete,
} as const;
type GetAllSkillsGetSchema = {
  method: 'get';
  url: '/skills';
  security: ['HTTPBearer'];
};
type GetAllSkillsGetParameters = undefined;
type GetAllSkillsGetData = paths['/skills']['get']['responses']['200']['content']['application/json'];
type GetAllSkillsGetError = unknown;
type CreateSkillsPostSchema = {
  method: 'post';
  url: '/skills';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateSkillsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateSkillsPostData = paths['/skills']['post']['responses']['200']['content']['application/json'];
type CreateSkillsPostError = paths['/skills']['post']['responses']['422']['content']['application/json'];
type CreateSkillsPostBody = paths['/skills']['post']['requestBody']['content']['application/json'];
type UpdateSkillsSkillIdPatchSchema = {
  method: 'patch';
  url: '/skills/{skill_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateSkillsSkillIdPatchParameters = paths['/skills/{skill_id}']['patch']['parameters'];
type UpdateSkillsSkillIdPatchData =
  paths['/skills/{skill_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateSkillsSkillIdPatchError =
  paths['/skills/{skill_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateSkillsSkillIdPatchBody = paths['/skills/{skill_id}']['patch']['requestBody']['content']['application/json'];
type RemoveSkillsSkillIdDeleteSchema = {
  method: 'delete';
  url: '/skills/{skill_id}';
  security: ['HTTPBearer'];
};
type RemoveSkillsSkillIdDeleteParameters = paths['/skills/{skill_id}']['delete']['parameters'];
type RemoveSkillsSkillIdDeleteData =
  paths['/skills/{skill_id}']['delete']['responses']['200']['content']['application/json'];
type RemoveSkillsSkillIdDeleteError =
  paths['/skills/{skill_id}']['delete']['responses']['422']['content']['application/json'];
type RemoveSkillsSkillIdDeleteBody = undefined;
